/**
 * @file ConfirmDeleteModal.js
 * @description Confirmation popup window when performing a delete action
 *
 * @version 1.0.0
 * @author Carmelino Galang
 * @copyright Copyright (c) 2024, NetCyberOps LLC
 */

import React from "react";
import { Modal } from "react-bootstrap";
import { AlertTriangle, Trash2 } from "lucide-react";
import Button from "@components/Button/Button";
import "./ConfirmDeleteModal.css";
import NcoModalHeader from "@components/NcoModalHeader/NcoModalHeader";

export default function ConfirmDeleteModal({
  showConfirmationModal,
  handleCloseConfirmationModal,
  message,
  handleDelete,
  data,
  title = "Delete?",
  subtitle = "This action can’t be undone",
  confirmLabel = "Delete",
  warning = null,
  loading = false,
  icon = <Trash2 size={19} />,
  variant = "danger",
}) {
  const danger = variant === "danger";
  const close = () => !loading && handleCloseConfirmationModal();

  return (
    <Modal
      show={showConfirmationModal}
      onHide={close}
      centered
      className={`nco-modal delete-confirmation-modal${danger ? " is-danger" : ""}`}
      aria-labelledby={title ? "confirm-delete-title" : undefined}
    >
      {/* title={null} drops the header (plain confirmation prompt) */}
      {title && <NcoModalHeader icon={icon} danger={danger} title={title} titleId="confirm-delete-title" subtitle={subtitle} onClose={close}/>}
      <Modal.Body className="nco-modal-body">
        <p className="confirm-delete-text">{message}</p>
        {warning && (
          <div className="confirm-delete-warn">
            <AlertTriangle size={16} />
            {warning}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="nco-modal-footer">
        <Button variant="secondary" onClick={close} disabled={loading}>
          Cancel
        </Button>
        <Button variant={variant} onClick={() => handleDelete(data)} loading={loading}>
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
